import { IHttpCall } from '@hc-frontend/core-utils-net';
import { IHttpRequest } from '@hc-frontend/core-utils-net';
import { z } from 'zod';

export const SubsidyPersonSchema = z.object({
  FirstName: z.string().optional(),
  LastName: z.string().optional(),
  TypePerson: z.number(),
  TypeGender: z.number(),
  TabacoUse: z.number(),
  DateOfBirth: z.string(),
});

export const GetSubsidyRequestSchema = z.object({
  Product: z.string(),
  Placement: z.string(),
  Answers: z.array(z.string()),
  SRC: z.string(),
  ircid: z.string(),
  Applicant: z.object({
    HouseIncome: z.number().optional(),
    HouseHoldSize: z.number().optional(),
    Holder: SubsidyPersonSchema,
    Couple: SubsidyPersonSchema.optional(),
    Children: z.array(SubsidyPersonSchema),
    GeoLocation: z.object({
      zipCode: z.string(),
      stateName: z.string(),
      stateAcronym: z.string(),
      countyName: z.string(),
      city: z.string(),
    }),
  }),
  TrackObject: z
    .object({
      SessionId: z.string(),
      userId: z.string(),
      src: z.string(),
      pcid: z.string(),
      subid: z.string(),
      utm_source: z.string(),
      utm_campaign: z.string(),
      utm_medium: z.string(),
      iv: z.string(),
      gclid: z.string(),
      ircid: z.string(),
      agentId: z.string(),
    })
    .partial(),
});

export type GetSubsidyRequest = z.infer<typeof GetSubsidyRequestSchema>;

export const GetSubsidyResponseSchema = z.object({
  subsidyMessage: z.string(),
  requestData: z.string(),
  title: z.string(),
  subsidyValue: z.number(),
  silverPlanAmount: z.number(),
  subsidyMsgType: z.number(),
});

export type GetSubsidyResponse = z.infer<typeof GetSubsidyResponseSchema>;

export type GetSubsidyOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};
